import { NewBaseOption } from '../types';

export const createNewOption = (value: string): NewBaseOption => ({
  __isNew__: true,
  label: value,
  value,
});
